// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Lp-z","outfitFeedbackSection":"Mp-z"};